import React, { useState } from "react";
import "../style.css";

const carouselData = [
  {
    img: "https://cdn.saksfifthavenue.com/is/image/saks/0400021604543_BLACK?wid=380&hei=506&qlt=70&resMode=sharp2&op_usm=1.2,1,6,0",
    alt: "Medium Grainy Calfskin Rockstud Bag",
    description: "Saks Fifth Avenue - Luxury studded calfskin handbag"
  },
  {
    img: "https://assets.aritzia.com/image/upload/medium/f24_a01_102669_23354_on_a.jpg",
    alt: "Olive knit top",
    description: "Aritzia - Fitted minimalist olive knit for fall layering"
  },
  {
    img: "https://static.zara.net/assets/public/84fb/3af8/58bc4953bca9/14fe4caa98af/13578410700-e1/13578410700-e1.jpg?ts=1735907677609&w=380",
    alt: "TEXTURED STUDDED MARY JANES",
    description: "Zara - Studded Mary Janes, perfect blend of elegance and edge"
  },
  {
    img: "https://assets.aritzia.com/image/upload/medium/f24_a05_84550_1274_on_a.jpg",
    alt: "The Super Puff₂O™ - Rainstop™",
    description: "Aritzia - Iconic Super Puff₂O™ jacket for all-weather fashion"
  },
  {
    img: "https://static.zara.net/assets/public/92aa/c4ec/8d464429a06f/837c28ac9f61/15405510700-e1/15405510700-e1.jpg?ts=1736328723140&w=380",
    alt: "ATHLETIC SNEAKERS",
    description: "Zara - Sleek athletic sneakers for modern casual looks"
  },
  {
    img: "https://assets.aritzia.com/image/upload/medium/f24_a06_77775_1274_on_a.jpg",
    alt: "The Effortless Pant™ - Crepette™",
    description: "Aritzia - Best-selling Effortless Pant™ for timeless style"
  },
  {
    img: "https://assets.aritzia.com/image/upload/medium/f24_a03_114360_11420_on_a.jpg",
    alt: "golightly cardigan",
    description: "Aritzia - Cozy golightly cardigan, lightweight layering essential"
  }
];


const PopularSearches = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleItemsCount = 5; // Number of items to display at once

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselData.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + carouselData.length) % carouselData.length
    );
  };

  // Get the visible items, taking wrap-around into account
  const getVisibleItems = () => {
    const items = [];
    for (let i = 0; i < visibleItemsCount; i++) {
      const index = (currentIndex + i) % carouselData.length;
      items.push(carouselData[index]);
    }
    return items;
  };

  const visibleItems = getVisibleItems();

  return (
    <section className="popular-searches">
      <h2>Popular Searches</h2>
      <div className="carousel">
        <button
          className="carousel-arrow left"
          style={{ marginLeft: "10px" }}
          onClick={prevSlide}
        >
          &lt;
        </button>
        <div className="carousel-items">
          {visibleItems.map((item, index) => (
            <div className="carousel-item" key={index}>
              <img src={item.img} alt={item.alt} />
              <p>"{item.description}"</p>
            </div>
          ))}
        </div>
        <button
          className="carousel-arrow right"
          style={{ marginRight: "10px" }}
          onClick={nextSlide}
        >
          &gt;
        </button>
      </div>
    </section>
  );
};

export default PopularSearches;
